import React from 'react';
import AuthorizationCheck from '../auth/authorizationCheck';

class ProductSituationDetails extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const product = this.props.product;

        if(!this.props.loaded){

            return ('Details non trouvé');
        }

        if(this.props.product == undefined){

            return ('Produit non trouvé');
        }
        
       
        
        const orderProducts = this.props.orderProductSituation;
        const shipmentProductSituation = this.props.shipmentProductSituation;

        const orderProductSituation = orderProducts.filter(p => p.quantity > 0);

        

        return (
            <div className="card card-default" style={{fontSize:'14px'}}>

            



                <div className="card-body">

                    <div className="card-header">{ product.name + ' ' + product.model + ' ' + product.brand + ' ' + product.color + ' ' + product.size}</div>

                    {orderProductSituation.length > 0 && orderProductSituation.map(orderProduct =>


                        <div className="row mb-2 border-bottom">
                            <div className="col">
                                
                                <div>{ (this.props.userRole == 'MANAGER' || this.props.userRole == 'SUPER-ADMIN' || this.props.userRole == 'ADMIN') ? <a href={ '/orderProducts?orderId='+ orderProduct.orderId }>{ orderProduct.description}</a>:orderProduct.description}</div>
                            </div>

                            <div className="col">
                                <div>Quantité</div>
                                <div>{orderProduct.quantity}</div>
                            </div>

                            <div className="col">
                                <div>Statut</div>
                                <div className="btn btn-success mb-2">{orderProduct.status}</div>
                            </div>




                        </div>
                    )}


                    <div className="card-header">EMBARQUEMENTS</div>

                    {shipmentProductSituation.length > 0 && shipmentProductSituation.map(shipmentProduct => {

                        let isProposal = '';

                        if(shipmentProduct.proposal == 1){

                            isProposal = <span className="badge bg-info"> PROPOSITION</span>;
                        }
                        
                        return <div className="row mb-2 border-bottom" >
                            <div className="col">
                                <div className='text-primary'>Numero</div>
                                <div>{shipmentProduct.containerId}</div>
                                <div className='text-primary mt-2'>Description</div>
                                <div>{shipmentProduct.description}</div>

                            </div>

                            <div className="col">
                                <div className='text-primary'>Quantité</div>
                                <div>{shipmentProduct.quantity}</div>

                            </div>
                            <div className="col-md-3">
                                <div className='text-primary'>Date d'embarquement</div>
                                <div>{shipmentProduct.shipmentDate}</div>
                            </div>
                            <div className="col">
                               
                                <div className='text-primary'>Date d'arrivée</div>
                                <div>{shipmentProduct.arrivalDate}</div>
                            </div>
                            <div className='col'> {isProposal} </div>

                        </div>
    })}
                </div>
            </div>

        )
    }

}

export default ProductSituationDetails;